import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { StyleSheet } from '@react-pdf/renderer';
import { PDF_FONT_SIZE } from './constants';

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 10,
    paddingBottom: 10,
    gap: 10,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 5,
  },
  badge: {
    width: 8,
    height: 8,
    borderRadius: 4,
    marginRight: 8,
  },
  successBadge: {
    backgroundColor: '#52c41a',
  },
  yellowBadge: {
    backgroundColor: '#fadb14',
  },
  errorBadge: {
    backgroundColor: '#ff4d4f',
  },
  text: {
    fontSize: PDF_FONT_SIZE.TITLE,
  },
});

export const GlosaryColorsPDF = () => {
  return (
    <View style={styles.container}>
      <View style={styles.row}>
        <View style={[styles.badge, styles.successBadge]} />
        <Text style={styles.text}>Marca Agregada o Completada Automaticamente</Text>
      </View>
      <View style={styles.row}>
        <View style={[styles.badge, styles.yellowBadge]} />
        <Text style={styles.text}>Marca Modificada</Text>
      </View>
      <View style={styles.row}>
        <View style={[styles.badge, styles.errorBadge]} />
        <Text style={styles.text}>Alteraciones en Marcaciones</Text>
      </View>
    </View>
  );
};

export default GlosaryColorsPDF;